import { useEffect, useState } from 'react'

import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'
import { Dropdown } from 'react-bootstrap'

import { ComparisonVariation, ReactDefaultPriceProps } from './types'
import { PRICE_TAG } from '../../../assets/images'
import { getLocalStorage } from '../../../utils/local-storage-util'
import { getImageSrc } from '../../../utils/local-util'
import { getAttributeValue, hasCFConditionals } from '../../../utils/rule-builder-util'
import ReactText from '../../ReactText'
import IsInEditorText from '../../shared/IsInEditorText'
import './ReactDefaultPrice.scss'

const ReactDefaultPrice = (props: ReactDefaultPriceProps) => {
  const {
    additionalNote = '',
    cardType,
    elements = {},
    index,
    isInEditor = false,
    price = '',
    priceDropdownIcon,
    priceDropdownIconAlt,
    priceTagIcon = PRICE_TAG,
    ruleExpression = '',
    scratchPrice = '',
    term = '',
    tokenProperties,
    variation = ComparisonVariation.NO_PRICEDROPDOWN
  } = props

  const activeModalIndex = getLocalStorage('activeModalIndex')
  const offerIndex = activeModalIndex || index
  const offers = useFlexOffers(ruleExpression)

  const getValue = (attribute: any, propertyName?: string) => {
    const hasJsonAttribute = hasCFConditionals(attribute)
    if (hasJsonAttribute) {
      const jsonAttribute = (elements as any)?.[`${propertyName}_json`]
      return getAttributeValue(jsonAttribute, offers, offerIndex, tokenProperties, propertyName, hasJsonAttribute)
    }
    return getAttributeValue(attribute, offers, offerIndex, tokenProperties, propertyName)
  }

  const [displayPriceDetails, setDisplayPriceDetails] = useState({ term, price, scratchPrice, additionalNote })
  const [pricedropdownItems, setPricedropdownItems] = useState<any>([])
  const displayPriceDropdown = variation == ComparisonVariation.PRICE_DROPDOWN && pricedropdownItems?.length > 0

  useEffect(() => {
    let priceValue, scratchPriceValue, termValue, discountValue
    if (Object.keys(elements).length > 0) {
      if (variation == ComparisonVariation.PRICE_DROPDOWN) {
        const { pricedropdown } = elements
        const pricedropdownValue = getValue(pricedropdown, 'pricedropdown')
        const pricedropdownValues = []

        for (let i = 0; i < pricedropdownValue.length; i++) {
          const price = getValue(pricedropdownValue[i].price, 'price')
          const scratchPrice = getValue(pricedropdownValue[i]?.scratchPrice, 'scratchPrice')
          const term = getValue(pricedropdownValue[i]?.term, 'term')
          const additionalNote = getValue(pricedropdownValue[i]?.additionalNote, 'additionalNote')
          const pricedropdownItem = { price, scratchPrice, term, additionalNote }
          pricedropdownValues.push(pricedropdownItem)
        }
        setPricedropdownItems(pricedropdownValues)
        priceValue = pricedropdownValues[0]?.price
        scratchPriceValue = pricedropdownValues[0]?.scratchPrice
        termValue = pricedropdownValues[0]?.term
        discountValue = pricedropdownValues[0]?.additionalNote
      } else {
        const { price, scratchPrice, term, discount } = elements
        priceValue = getValue(price, 'price')
        scratchPriceValue = getValue(scratchPrice, 'scratchPrice')
        termValue = getValue(term, 'term')
        discountValue = getValue(discount, 'discount')
      }
    } else {
      priceValue = price
      termValue = term
      scratchPriceValue = scratchPrice
      discountValue = additionalNote
    }
    setDisplayPriceDetails({
      term: termValue,
      price: priceValue,
      scratchPrice: scratchPriceValue,
      additionalNote: discountValue
    })
  }, [])

  return (
    <>
      {IsInEditorText(isInEditor, 'React Price')}
      {((displayPriceDetails.price && displayPriceDetails.price.length > 0) || displayPriceDetails.term) && (
        <Dropdown className={`react-default-price-container variation-${variation}`} align={{ xs: 'end' }}>
          <Dropdown.Toggle
            className={`dropdown-toggle ${variation === ComparisonVariation.NO_PRICEDROPDOWN && 'cursor-text'}`}
          >
            <div className={`react-price ${cardType}`}>
              <div className='react-price-col1'>
                <div className='price-content'>
                  {displayPriceDetails.price && (
                    <div className='price m-0'>
                      {displayPriceDetails.price && (
                        <ReactText className='details-price' text={displayPriceDetails.price} isParsed />
                      )}
                      {displayPriceDetails.scratchPrice &&
                        displayPriceDetails.price !== displayPriceDetails.scratchPrice && (
                          <ReactText className='scratch-price' text={displayPriceDetails.scratchPrice} isParsed />
                        )}
                    </div>
                  )}
                  {displayPriceDetails.term && (
                    <ReactText className='product-term m-0' text={displayPriceDetails.term} isParsed />
                  )}
                </div>
                {displayPriceDetails.additionalNote &&
                  displayPriceDetails.additionalNote.length > 0 &&
                  !displayPriceDetails.additionalNote?.includes('0%') && (
                    <p className='additional-details m-0'>
                      <img className='price-tag-icon' src={getImageSrc(priceTagIcon)} alt={'price-tag-icon'} />
                      <ReactText className='additional-note' text={displayPriceDetails.additionalNote} isParsed />
                    </p>
                  )}
              </div>
              {displayPriceDropdown && (
                <div className='react-price-col2'>
                  <img className='pricedropdown-icon' src={priceDropdownIcon} alt={priceDropdownIconAlt} />
                </div>
              )}
            </div>
          </Dropdown.Toggle>
          {displayPriceDropdown && (
            <Dropdown.Menu className='react-price-dropdown'>
              {pricedropdownItems?.map((dropdownItem: any, dropDownIndex: number) => {
                const { term, price, scratchPrice, additionalNote } = dropdownItem

                if (dropdownItem.price !== displayPriceDetails.price) {
                  return (
                    <Dropdown.Item
                      key={dropdownItem.term + dropDownIndex}
                      className='dropdown-item'
                      onClick={() =>
                        setDisplayPriceDetails({
                          term,
                          price,
                          scratchPrice,
                          additionalNote
                        })
                      }
                    >
                      <ReactText className='dropdown-price' text={price} isParsed />
                      <ReactText className='dropdown-agreement' text={term} isParsed />
                    </Dropdown.Item>
                  )
                }
              })}
            </Dropdown.Menu>
          )}
        </Dropdown>
      )}
    </>
  )
}

export default ReactDefaultPrice
